export default [
  { //  3-1
    path: "/ScienceEnterprise/HighNew",
    name: "HighNew",
    component: () => import("../views/ScienceEnterprise/HighNew"),
  },
  { //  3-2
    path: "/ScienceEnterprise/MiddleSmall",
    name: "MiddleSmall",
    component: () => import("../views/ScienceEnterprise/MiddleSmall"),
  },
  { //  3-3
    path: "/ScienceEnterprise/Mastery",
    name: "Mastery",
    component: () => import("../views/ScienceEnterprise/Mastery"),
  },
  { //  3-4
    path: "/ScienceEnterprise/Gazelle",
    name: "Gazelle",
    component: () => import("../views/ScienceEnterprise/Gazelle"),
  },
  { //  3-5
    path: "/ScienceEnterprise/LittleGiant",
    name: "LittleGiant",
    component: () => import("../views/ScienceEnterprise/LittleGiant"),
  },
];
